"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Generates placeholder style for each of the browsers supported by office-ui-fabric-react.
 * @param styles - The style to use.
 * @returns The placeholder style object for each browser depending on the placeholder directive it uses.
 */
function getPlaceholderStyles(styles) {
    return {
        selectors: {
            '::placeholder': styles,
            ':-ms-input-placeholder': styles,
            '::-ms-input-placeholder': styles // Edge
        }
    };
}
exports.getPlaceholderStyles = getPlaceholderStyles;
//# sourceMappingURL=getPlaceholderStyles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/styling/lib-commonjs/styles/getPlaceholderStyles.js
// module id = 588
// module chunks = 0